import { render, staticRenderFns } from "./ot-table-header.vue?vue&type=template&id=0865f229&scoped=true&"
import script from "./ot-table-header.vue?vue&type=script&lang=ts&"
export * from "./ot-table-header.vue?vue&type=script&lang=ts&"
import style0 from "./ot-table-header.vue?vue&type=style&index=0&id=0865f229&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865f229",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
